import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Seo from '../shared/Seo';

const MaintenanceLayout = () => {
    const siteId = useSelector(state => state.commonReducer.siteId);
    const siteName = useSelector(state => state.commonReducer.siteName);

    useEffect(() => {
        document.body.classList.add('maintenance-page');
        const htmlElement = document.documentElement;
        htmlElement.style.height = '100%';

        return () => {
            document.body.classList.remove('maintenance-page');
            htmlElement.style.height = 'auto';
        };
    }, []);

    return (
        <>
            <Seo title={`Maintenance | ` + siteName} description="Maintenance" keywords="Maintenance" />
            <section id="maintenance-page" className="maintenance-page">
                <header id="header" className="site-header" role="navigation">
                    <div className="navbar-header brand">
                        <div className="ua-logo-home logo-home">
                            <img alt="Uniform Advantage" className="logo" src="/UA-logo.svg"/>
                        </div>
                        <div className="logo-home">
                            <img src={`https://www.emailconfirmations.com/images/b2b/` + siteId.replace('_S', '') + `_logo.webp`} alt={siteName} loading='lazy' className={siteName.replace(/[^A-Za-z\/-]/g, '-').toLowerCase()} />
                        </div>
                    </div>
                </header>
                <div className="maintenance-content">
                    <h1>We’ll Be Back by <br class="d-md-none" />7AM/ET!</h1>
                    <p className='mb-0'>We’re making some upgrades to keep things running smoothly. Our site is down for scheduled maintenance, but don’t worry—we’ll be back online by <b>7AM/ET</b>. Thanks for bearing with us!</p>
                </div>
            </section>
        </>
    );
}

export default MaintenanceLayout;